import React from 'react';
import { Box, Grid2, Paper, Typography, Chip, Link } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import GitHubIcon from '@mui/icons-material/GitHub';
import { skills } from '../utils/utils';
import { motion } from 'framer-motion';

export default function Projects({ darkMode }) {
    const projects = [
        {
            title: 'Zenith Monitor',
            description: (
                <>
                    Aplicativo em React Native do <Link
                        href="https://zenith-aerospace.netlify.app/"
                        underline="none"
                        variant="body1"
                        target="_blank"
                        rel="noopener"
                        sx={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                        {' '}
                        Zenith Aeroespace
                        <OpenInNewIcon fontSize="small" />
                    </Link>, um grupo extracurricular da EESC -
                    USP focado em lançamento de satélites e sondas aeroespaciais. Desenvolvi o
                    módulo de comunicação via Bluetooth para auxiliar a localização e recuperação de
                    sondas aeroespaciais.
                </>
            ),
            image: 'https://i.postimg.cc/50f3dWYs/500104907-f0ae9dbe-c9f4-4458-a2e9-1615a81910ae.png',
            skills: [
                'React',
                'React Native',
                'TypeScript',
                'Expo',
                'Material UI',
                'Figma',
            ],
            link: 'https://github.com/zenitheesc/zenith-monitor-rn',
        },
        {
            title: 'App para doação de alimentos',
            description: (
                <>
                    Um aplicativo em React Native para registrar o recebimento de doações de
                    alimentos e outros produtos. O app foi desenvolvido para a instituição
                    <Link
                        href="https://rotarybandeirantes.org/"
                        underline="none"
                        variant="body1"
                        target="_blank"
                        rel="noopener"
                        sx={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                        {' '}
                        Rotary Club de São Carlos Bandeirantes
                        <OpenInNewIcon fontSize="small" />
                    </Link>
                    , que atua na cidade de São Carlos, interior de São Paulo. O app permite
                    registrar doações por meio da leitura do código de barras dos produtos,
                    visualizar doações realizadas e a gerar relatórios de campanhas passadas.
                </>
            ),
            image: 'https://i.postimg.cc/q77qWCN3/Whats-App-Image-2024-11-08-at-15-19-23.jpg',
            skills: [
                'React Native',
                'Javascript',
                'TypeScript',
                'NodeJS',
                'PostgreSQL',
                'Expo Go',
                'Material UI',
                'Figma',
            ],
            link: 'https://github.com/itMatos/app-doacao-de-alimentos',
        },
        {
            title: 'Lojinha Campanha USP do Agasalho',
            description: (
                <>
                    Uma solução em React que surgiu da necessidade de automatizar o controle,
                    gerenciamento de estoque e vendas de produtos da{' '}
                    <Link
                        href="https://campanhauspdoagasalho.eesc.usp.br"
                        underline="none"
                        variant="body1"
                        target="_blank"
                        rel="noopener"
                        sx={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                        Campanha USP do Agasalho
                        <OpenInNewIcon fontSize="small" />
                    </Link>
                    , uma atividade de extensão da{' '}
                    <Link
                        href="https://www5.usp.br/"
                        underline="none"
                        variant="body1"
                        target="_blank"
                        rel="noopener"
                        sx={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                        Universidade de São Paulo
                        <OpenInNewIcon fontSize="small" />
                    </Link>
                    . Nele, é possível cadastrar produtos que serão vendidos individualmente ou em
                    conjunto, visualizar o estoque desses produtos, realizar vendas e visualizar o
                    histórico dessas vendas.
                </>
            ),
            image: 'https://github.com/itMatos/lojinha-campanha-usp/assets/46801239/a7eaf20a-7e46-417a-a666-d62d6c98eeb2',
            skills: [
                'React',
                'React Native',
                'TypeScript',
                'Javascript',
                'NodeJS',
                'Material UI',
                'Figma',
            ],
            link: 'https://github.com/itMatos/lojinha-campanha-usp',
        },
        {
            title: 'SurveyPro - Backend',
            description: (
                <>
                    Aplicação backend criado com NodeJS para a plataforma de pesquisa SurveyPro. O
                    projeto consiste em um sistema de gerenciamento de pesquisas, onde é possível
                    criar, editar, excluir e visualizar pesquisas e respostas.
                </>
            ),
            image: 'https://i.postimg.cc/RhrFX0Pr/image.jpg',
            skills: ['TypeScript', 'NodeJS', 'PostgreSQL', 'NestJS'],
            link: 'https://github.com/itMatos/backend-api-polls-nestjs',
        },
        // {
        //     title: 'App de receitas',
        //     description: (
        //         <>
        //             Aplicação frontend criado com ReactJS. Consiste em um app de receitas onde é
        //             possível visualizar receitas, favoritar receitas, visualizar receitas favoritas
        //             e pesquisar receitas.
        //         </>
        //     ),
        //     image: 'https://i.postimg.cc/FH30Q1XZ/login-app-receitas.png',
        //     skills: ['React', 'Javascript', 'HTML', 'CSS'],
        //     link: 'https://github.com/itMatos/app-de-receitas',
        // },
    ];

    const containerVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 },
    };

    return (
        <Grid2
            container
            sx={{ justifyContent: 'center', backgroundColor: darkMode ? '#0E0E0F55' : '#F5F5F588' }}
        >
            <Grid2
                item
                xs={12}
                sx={{
                    width: '100%',
                    justifyContent: 'center',
                    textAlign: 'center',
                }}
            >
                <Box xs={12}>
                    <Typography variant="h2" fontWeight={500} mb={2}>
                        Projetos pessoais
                    </Typography>
                </Box>
            </Grid2>

            {projects.map((project, index) => (
                <Grid2 item xs={12} md={6} key={index} maxWidth={'800px'}>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: index * 0.2 }}
                        variants={containerVariants}
                    >
                        <Paper
                            elevation={0}
                            sx={{
                                padding: 2,
                                margin: 1,
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                alignItems: 'center',
                                borderRadius: 2,
                                backgroundColor: darkMode ? '#2A2A2A' : '#FFF',
                            }}
                        >
                            <Box sx={{ margin: 1 }}>
                                <Box
                                    component="img"
                                    src={project.image}
                                    width={250}
                                    height={450}
                                    alt={project.title}
                                    loading="lazy"
                                    sx={{
                                        borderRadius: '10px',
                                        objectFit: 'cover',
                                        objectPosition: 'top',
                                    }}
                                />
                            </Box>

                            <Box sx={{ alignItems: 'center' }}>
                                <Box>
                                    {index === 0 && (
                                        <Chip
                                            label="Em andamento"
                                            color="warning"
                                            size="small"
                                            sx={{
                                                alignSelf: 'flex-end',
                                                m: 1,
                                            }}
                                        />
                                    )}
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 1,
                                        padding: 1,
                                        justifyContent: 'flex-start',
                                        flexDirection: { xs: 'column', md: 'row' },
                                    }}
                                >
                                    <Typography variant="h5" gutterBottom fontWeight={500}>
                                        {project.title}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography
                                        variant="body1"
                                        align="justify"
                                        gutterBottom
                                        padding={1}
                                    >
                                        {project.description}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }} padding={1}>
                                    {project.skills.map((skill, skillIndex) => (
                                        <Chip
                                            key={skillIndex}
                                            label={skill}
                                            color="warning"
                                            size="small"
                                            icon={skills[skill]}
                                            variant="outlined"
                                            sx={{
                                                '.MuiChip-icon': {
                                                    width: 18,
                                                    height: 18,
                                                },
                                                padding: 1,
                                                color: 'inherit',
                                            }}
                                        />
                                    ))}
                                </Box>

                                <Box
                                    sx={{
                                        margin: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Link
                                        variant="h3"
                                        target="_blank"
                                        rel="noopener"
                                        href={project.link}
                                        sx={{
                                            color: 'inherit',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                        }}
                                        underline="none"
                                    >
                                        <Typography variant="h5" fontWeight={500}>
                                            Ver código fonte
                                        </Typography>
                                        <GitHubIcon fontSize="medium" />
                                    </Link>
                                </Box>
                            </Box>
                        </Paper>
                    </motion.div>
                </Grid2>
            ))}
        </Grid2>
    );
}
